import { render } from "./PageParameterTahunAjaran.vue?vue&type=template&id=719c68d0"
import script from "./PageParameterTahunAjaran.vue?vue&type=script&lang=js"
export * from "./PageParameterTahunAjaran.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__